import { render } from "./createWarehouse.vue?vue&type=template&id=c0b6fe16&scoped=true"
import script from "./createWarehouse.vue?vue&type=script&lang=js"
export * from "./createWarehouse.vue?vue&type=script&lang=js"

import "./createWarehouse.vue?vue&type=style&index=0&id=c0b6fe16&lang=less&scoped=true"

import exportComponent from "D:\\New Git\\tl-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0b6fe16"]])

export default __exports__